import { PluginCard, PluginCardCommonProps } from '../../../plugins-tab/PluginCard';
import { PluginDynamicPathSvg } from '../../icons';
import { dynamicPathPluginDesc1 } from './DynamicPathPage';

export const DynamicPathPluginCard = (props: PluginCardCommonProps) => {
  return (
    <PluginCard
      svgIcon={<PluginDynamicPathSvg />}
      title="Dynamic Path Plugin"
      description={dynamicPathPluginDesc1}
      {...props}
    />
  );
};
